import React from 'react'
import PropTypes from 'prop-types'

const isClient = typeof window !== 'undefined'

const Marker = ({ text }) => <span>{text}</span>
const GoogleMap = () => {
  return (
    <section className="google-map" style={{ height: '100%', width: '100%' }}>
      <div className="h-full w-full">
        {isClient && (
          <iframe width="600" height="450" frameBorder="0" style={{ height: "100%", width: "100%" }} src="https://www.google.com/maps/embed/v1/place?q=place_id:ChIJke5hKST2KowRQ0O5XBzsH2c&key=AIzaSyBDgbrYCmwXPGDW9ITT9xT8lZTJGg-1XXQ" allowFullScreen />
        )}
      </div>
    </section>
  )
}

Marker.propTypes = {
  text: PropTypes.string
}

export default GoogleMap